import { render, staticRenderFns } from "./RegisterPitch.vue?vue&type=template&id=7b258168&scoped=true&"
import script from "./RegisterPitch.vue?vue&type=script&lang=js&"
export * from "./RegisterPitch.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPitch.vue?vue&type=style&index=0&id=7b258168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b258168",
  null
  
)

export default component.exports